import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const NewDealDetailLayout = () => {
     const navList = useNav();
  let {DealAccountBottomHeader, DealAccountTopHeader} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={DealAccountBottomHeader} topTabs={DealAccountTopHeader} />
            <Outlet />
        </div>
    )
}

export default NewDealDetailLayout;
